/** Shared card styling for recruiting campaign profile sections (form + read-only). */

export const RECRUIT_PROFILE_SECTION_TITLES = {
  officeAddress: "Office address",
  additionalOffices: "Additional offices",
  officesScale: "Offices & credibility",
  leadTargeting: "Lead Targeting for Campaign",
  commonObjections: "Common objections",
}

/** Section titles that render their own nested panels (no extra wrapper). */
export const RECRUIT_PROFILE_SELF_NESTED_TITLES = new Set([
  RECRUIT_PROFILE_SECTION_TITLES.officeAddress,
  RECRUIT_PROFILE_SECTION_TITLES.additionalOffices,
  RECRUIT_PROFILE_SECTION_TITLES.officesScale,
  "Key features",
  "Bio highlights",
  RECRUIT_PROFILE_SECTION_TITLES.commonObjections,
])

/**
 * @param {string} title
 * @returns {"accent"}
 */
export function recruitProfileSectionVariant(title) {
  void title
  return "accent"
}

function brand(theme, shade) {
  return (
    theme.palette.colors?.[shade] ??
    theme.palette.primary[shade === "brand50" ? "light" : "main"]
  )
}

/** @param {import("@mui/material").Theme} theme */
export function recruitProfileSectionCardSx(theme) {
  const accent = theme.palette.colors?.brand500 ?? theme.palette.primary.main

  return {
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: 2,
    border: `1px solid ${
      theme.palette.colors?.brand200 ?? theme.palette.divider
    }`,
    borderLeftWidth: 4,
    borderLeftColor: accent,
    boxShadow:
      "0 2px 10px -4px rgba(137, 47, 206, 0.12), 0 1px 4px -2px rgba(52, 64, 84, 0.06)",
    overflow: "hidden",
  }
}

/** @param {import("@mui/material").Theme} theme */
export function recruitProfileSectionHeaderSx(theme) {
  return {
    px: 2,
    py: 1.5,
    background: `linear-gradient(135deg, ${brand(
      theme,
      "brand50"
    )}55 0%, rgba(255, 255, 255, 0.96) 72%)`,
    borderBottom: `1px solid ${
      theme.palette.colors?.brand100 ?? theme.palette.divider
    }`,
    "& .MuiCardHeader-content": { overflow: "visible" },
  }
}

/** Nested panel inside sections (address block, office tier, field groups, etc.). */
export function recruitProfileNestedPanelSx(theme) {
  return {
    borderRadius: 1.5,
    border: `1px solid ${
      theme.palette.colors?.brand200 ?? theme.palette.divider
    }`,
    bgcolor: theme.palette.colors?.brand50
      ? `${theme.palette.colors.brand50}66`
      : "action.hover",
    px: { xs: 1.5, sm: 2 },
    py: 1.5,
  }
}

/** Label-above-value cell in 2-column read-only grids. */
export function recruitProfileDisplayFieldSx(theme, { empty = false } = {}) {
  return {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0,
    p: 1.5,
    borderRadius: 1.5,
    border: `1px solid ${
      theme.palette.colors?.brand200 ?? theme.palette.divider
    }`,
    bgcolor: empty
      ? "transparent"
      : theme.palette.colors?.brand50
      ? `${theme.palette.colors.brand50}44`
      : "background.paper",
  }
}
